import { Paper, Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/MarketplaceActions";


const styles = (theme) => ({
   root: {
      color: theme.palette.text.primary,
   },
   paper: {
      padding: "2px 4px",
      display: "sm:flex xs:flex-wrap",
      alignItems: "center",
      borderRadius: "20px",
      width: "75%",
   },
   paperInativo: {
      backgroundColor: theme.palette.type === "dark" ? "#666" : "#CCC",
   },
});

class MarketplaceList extends XAPPComponent {
   getIcon = (_AIcone) => {
      return <img src={_AIcone} width={100} height={100} />;
   };



   render() {
      const { openDialog, integracoes, get, xappRouteParams, sistemas } = this.props;

      return (
         <React.Fragment>
            <div className="flex justify-center flex-wrap">
               {integracoes.map((item) => (
                  <Paper
                     className={clsx("w-full h-300 p-8 sm:w-256 m-8 cursor-pointer")}
                     key={item.tipo}
                     id={"divmain_" + item.tipo}
                     onClick={() => {
                        if (this.existsIntegracao(sistemas, xappRouteParams.empresa, item.tipo)) {
                           get(xappRouteParams, item.tipo);
                        }
                        openDialog(item);
                     }}
                  >
                     <div className="flex flex-col items-center justify-center w-full py-8">{this.getIcon(item.icone)}</div>
                     <div className="flex text-center justify-center w-full">
                        <Typography className="text-18 font-400 pt-8" color="textSecondary">
                           {item.nome}
                        </Typography>
                     </div>
                     <div className="flex text-center justify-center w-full">
                        <Typography className="text-14 font-400 pt-8" color="textSecondary">
                           {item.descricao}
                        </Typography>
                     </div>
                  </Paper>
               ))}
            </div>
         </React.Fragment>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         get: Actions.get,
         showMessage: AppActions.showMessage,
      },
      dispatch
   );
}

function mapStateToProps({ Marketplace, auth }) {
   return {
      Marketplace: Marketplace,
      sistemas: auth.user.data.settings.sistemas,
   };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketplaceList)));
